export default {
  methods: {
    formatPrice(value) {
      if (value == null) return "-";
      return Intl.NumberFormat(this.$i18n.locale, {
        style: "currency",
        currency: this.bom.currency
      }).format(value);
    },
    formatWeight(value) {
      if (value == null) return "-";
      return (
        value.toLocaleString(this.$i18n.locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + " kg"
      );
    },
  }
}